import React from 'react'
import { gsColors } from '../../styles/Variables'
import { Text, UnderlineButton } from '../../styles/Components'
import Button from '../../components/Button'
import PaymentMethodDetails from './PaymentMethodDetails'
import { useUserContext } from '../../components/UserContext'

const PaymentsAccountView = ({
  me,
  openDestroy,
  setDefaultPayment,
  toggleShowAddPaymentMethod,
  toggleIsPaymentMethodMenuVisible
}) => {
  const { user } = useUserContext()
  return (
    <div className="payments-account-view" data-testid="payments-account-view">
      <div className="default-payment">
        <Text weight={600} fontSize={18} margin='0 0 16px 0'>Default</Text>
        <div>
          <PaymentMethodDetails
            method={user?.paymentMethods.find(
              p => p.id === user?.defaultPaymentMethodId
            )}
          />
          <UnderlineButton onClick={() => openDestroy(user?.defaultPaymentMethodId)}>
            Delete
          </UnderlineButton>
        </div>
      </div>
      {me.paymentMethods.length > 1 && (
        <div className="other-payments">
          <Text weight={600} fontSize={18} margin='0 0 16px 0'>Other Payment Methods</Text>
          <div className="other-payments-list">
            {user?.paymentMethods
              .filter(p => p.id !== user?.defaultPaymentMethodId)
              .map((p) => (
                <div className='other-payment-item' key={p.id}>
                  <div className='payment-content'>
                    <PaymentMethodDetails method={p} />
                    <div className='payment-method-actions'>
                      <UnderlineButton
                        onClick={() => setDefaultPayment(p.id)}
                      >
                        Make Default
                      </UnderlineButton>
                      <UnderlineButton
                        onClick={() => openDestroy(p.id)}
                      >
                        Delete
                      </UnderlineButton>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      <div className='payment-account-footer'>
        <Button
          outline
          color='#000'
          data-testid="new-payment-btn"
          id="new-payment-btn"
          type="button"
          onClick={() => {
            toggleShowAddPaymentMethod()
            toggleIsPaymentMethodMenuVisible()
          }}
        >
          Add New Payment
        </Button>
        <div className="protection">
          <div className='image-container'>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src='/images/powered_by_stripe.svg' alt="Powered by Stripe" />
          </div>
          <Text fontSize={12} color={gsColors.meredithGrey}>Your personal information is protected.</Text>
        </div>
      </div>
    </div>
  )
}

export default PaymentsAccountView
